import { gql } from '@apollo/client'

export const Query = gql`
  query EditVenueContact($companyId: ID!, $venueId: ID!, $venueContactId: ID!) {
    venues(companyId: $companyId, filters: { idEq: $venueId }, first: 1) {
      nodes {
        id
        venueContacts(filters: { idEq: $venueContactId }, first: 1) {
          nodes {
            id
            user { id }
            name
            email
            phone
            contactType
          }
        }
      }
    }
  }
`
